module.exports = __webpack_public_path__ + "components/flag/static/square/pl-54107dd37aba7090159f161d330744ae.svg";